<template>
    <Modal ref="baseModal">
        <div class="modal-inner xl-size">
            <button class="close" @click="cancel"></button>
            <div class="modal-title">
                <h3 class="text-over">{{ input.curriculumName }}</h3>
            </div>
            <div class="modal-body">
              <div class="curriculum-intro editor-wrap" v-html="input.curriculumIntro"></div>
            </div>
            <div class="modal-footer mt-xs" style="justify-content: center;">
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, onMounted } from "vue";

export default {
    name: "SiteCurriculumDetailModal",
    components: {
        Modal,
    },
    props: {
    },
    setup() {
        const baseModal = ref(null);
        const resolvePromise = ref(null);

        onMounted(()=>{
            setTimeout(()=>{
                baseModal.value.isAdminWrap = true;
            }, 500);
        })

        const input = ref({
            curriculumName: '',
            curriculumIntro: '',
        });

        const show = (curriculumDetail) => {
            baseModal.value.open();
            return new Promise((resolve, _) => {
                resolvePromise.value = resolve;
            });
        };

        const cancel = () => {
            init();
            baseModal.value.close();
            resolvePromise.value(false);
        };

        const init = (paramObj) => {
            if(paramObj) {
                input.value = paramObj;
            } else {
                input.value = {
                    curriculumName: '',
                    curriculumIntro: '',
                }
            }
        }

        return { baseModal, show, confirm, cancel, input, init };
    },
};
</script>
<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .modal-title {
      border-bottom: 2px solid $black_color;
      padding: 0 !important;
      margin: 0 30px;
      h3 {
        width: 100%;
      }
    }

    .curriculum-intro {
        min-height: 550px;
        max-height: 550px;
        overflow-y: auto;
        word-break: break-word;
    }
</style>
